import { render } from "./PimProductsDetail.vue?vue&type=template&id=35930564&scoped=true&ts=true"
import script from "./PimProductsDetail.vue?vue&type=script&lang=ts"
export * from "./PimProductsDetail.vue?vue&type=script&lang=ts"

import "./PimProductsDetail.vue?vue&type=style&index=0&id=35930564&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35930564"]])

export default __exports__